
import React from "react";
import {
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
} from "@/components/ui/alert-dialog";

export function WelcomeDialogHeader() {
  return (
    <AlertDialogHeader>
      <AlertDialogTitle className="text-2xl text-center">Welcome to Sermon Planning</AlertDialogTitle>
      <AlertDialogDescription className="text-base mt-2 text-center">
        Create your first sermon plan to help organize your messages and connect with your congregation's spiritual needs.
      </AlertDialogDescription>
    </AlertDialogHeader>
  );
}
